export const iconFontAwesomePoliticalCheckToSlot = (
	<i className="fa-solid fa-check-to-slot"></i>
);
